<template>
  <kendo-window
      ref="kendoWindowRef"
      :title="'이메일 입력'"
      :modal="true"
      :width="'500px'"
      @open="onOpenWindow"
      style="z-index: 10004; transform: scale(1); opacity: 1; display:none;"
  >
    <div class="pop-container">
      <div class="pop-conts">
        <div class="pwindow">
          <ul class="filter_list">
            <li>
              <label>이메일<span class="forg">*</span></label>
              <ul class="w70">
                <li>
                  <kendo-maskedtextbox
                      class="w100"
                      v-model="sendMailAddr"
                      :placeholder="'이메일을 입력하세요.'"
                  >
                  </kendo-maskedtextbox>
                  안내 메일발송을 위해 이메일 주소를 입력해주세요
                </li>
              </ul>
            </li>
          </ul>
        </div>

        <div class="button_area w60 mgt30">
          <ul>
            <li class="w25">
              <button class="large_btn" @click="onClickCloseWindow">취소</button>
            </li>
            <li class="w25">
              <button class="large_btn orange ml5" @click="onClickSaveData">저장</button>
            </li>
          </ul>
        </div>
      </div>
    </div>

  </kendo-window>
</template>

<script>

import EtnersCommonUtil from "@/common/etners.common.util";
import EtnersLogisticsUtil from "@/common/etners.logistics.util";

export default {
  name: "GetMailAddrWindow",
  props: {
    propsSendInfo : {
      type : Object,
      required : false,
      default : function (){
        return {}
      }
    },
  },
  methods: {
    onOpenWindow () {
      const vm = this
      vm.sendMailAddr = vm.propsSendInfo.sendMailAddr
    },
    onClickSaveData () {
      const vm = this

      if(EtnersCommonUtil.isEmpty(vm.sendMailAddr)) {
        kendo.alert('이메일을 입력하세요.')
        return false
      } else if (EtnersCommonUtil.isNotEmpty(vm.sendMailAddr) && !EtnersLogisticsUtil.isEmailDomainAllowed(vm.sendMailAddr)) {
        kendo.alert(EtnersLogisticsUtil.getEmailDomainAllowedMsg(""))
        return
      }

      const mailAddr = {
        sendMailAddr: vm.sendMailAddr,
      }
      vm.$emit('getMailAddr', mailAddr)
    },
    onClickCloseWindow () {
      const vm = this
      const refs = this.$refs
      refs.kendoWindowRef.kendoWidget().close()
    },
  },
  data () {
    return {
      sendMailAddr: null,
    }
  }
}
</script>

<style scoped>

</style>